import React from 'react';
import { Link } from 'gatsby';
import ArrowLeft from '../assets/arrow_left_filled.svg';
import ArrowRight from '../assets/arrow_right_filled.svg';
import Line from './Line';

import { SimpleContainer } from './Container';

import * as css from './Pagination.module.css';

const Pagination = ({ pages, index }) => {
  const prev = pages[index - 1];
  const next = pages[index + 1];
  return (
    <SimpleContainer className={css.root} topLine bottomLine>
      {prev ? (
        <Link to={prev.slug} className={css.prev}>
          <ArrowLeft /> {prev.title}
        </Link>
      ) : (
        <span className={css.prev} />
      )}
      <Line className={css.mobileLine} />
      {next && (
        <Link to={next.slug} className={css.next}>
          {next.title} <ArrowRight />
        </Link>
      )}
    </SimpleContainer>
  );
};

export default Pagination;
